import React from 'react';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { Popover, PopoverAnchor, PopoverChevron, PopoverContent } from '@fiverr-private/popover';
import withTranslationButtonWrapper from '../../TranslationButtonWrapper';

interface TranslationButtonProps {
    toggled?: boolean;
    loading?: boolean;
    isOpen?: boolean;
    onClick?: () => void;
    setIsHovered?: (isHovered: boolean) => void;
}

const TranslationButton = ({
    toggled = false,
    loading = false,
    isOpen = false,
    onClick = noop,
    setIsHovered = noop,
}: TranslationButtonProps) => {
    const isOriginal = !toggled || loading;

    return (
        <Popover isOpen={isOpen}>
            <PopoverAnchor>
                <button
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={onClick}
                    disabled={loading}
                >
                    {isOriginal ? (
                        <I18n k={'machine_translation.translate'} />
                    ) : (
                        <I18n k={'machine_translation.lean_with_disclaimer.cta_translate'} />
                    )}
                </button>
            </PopoverAnchor>
            <PopoverContent backgroundColor="grey_1100">
                <PopoverChevron />
                <span className="co-grey-100">
                    <I18n k={'machine_translation.lean_with_disclaimer.tooltip'} />
                </span>
            </PopoverContent>
        </Popover>
    );
};

export default withTranslationButtonWrapper(TranslationButton) as React.FC<TranslationButtonProps>;
